import { Destructor } from 'util/destructors'
import { postMessage } from 'util/message'

type Screen = {
  time: number
  width: number
  height: number
}

function getScreen(): Screen {
  const time = Date.now()
  const width = document.documentElement.clientWidth
  const height = document.documentElement.clientHeight
  return { time, width, height }
}

function same(prev: Screen, next: Screen) {
  return next.width === prev.width && next.height === prev.height
}

export function attachResize(frame: HTMLIFrameElement): Destructor {
  let prev: Screen | undefined

  function update() {
    const next = getScreen()
    const skip = prev && same(prev, next)
    if (skip) return

    prev = next
    postMessage(frame, 'screen', next)
  }

  update()

  const listener = () => update()
  window.addEventListener('resize', listener)

  return () => window.removeEventListener('resize', listener)
}
